
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form20DataInfoType } from '@/types/Information/Form20';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form20Layout extends Vue {

    @Prop({required:true})
    result!: form20DataInfoType;

    dataReady = false;
    lawyerName = '';
    parties = '';

    mounted(){
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;
    }

    public extractInfo(){

        if (this.result.withdrawingLawyerName == 'Other'){
            this.lawyerName = this.result.withdrawingLawyerNameOther;
        } else {
            this.lawyerName = this.result.withdrawingLawyerName;
        }

        const index = this.result.objectingParties.indexOf('Other')

        if (index != -1){

            const partiesList = this.result.objectingParties.splice(index, 1);
            partiesList.push(this.result.objectingPartiesOther);
            this.parties = partiesList.join(', ');

        } else {
            this.parties = this.result.objectingParties.join(', ');
        }     
           
    }

    
}

